import { colors } from '@hydra/common/styles';

export default function getCompetitorColor (index: number) {
  switch (index) {
    case 0:
      return colors.competitor.light;
    case 1:
      return colors.competitor.main;
    case 2:
      return colors.competitor.dark;
  }
}
